import * as React from "react";
import { cn } from "@/lib/utils";
import "./feature-shell.css";

function FeatureShell({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="feature-shell"
      className={cn("feature-shell", className)}
      {...props}
    />
  );
}

function FeatureShellHeader({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="feature-shell-header"
      className={cn("feature-shell-header", className)}
      {...props}
    />
  );
}

function FeatureShellCopy({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="feature-shell-copy"
      className={cn("feature-shell-copy", className)}
      {...props}
    />
  );
}

function FeatureShellEyebrow({
  className,
  ...props
}: React.ComponentProps<"p">) {
  return (
    <p
      data-slot="feature-shell-eyebrow"
      className={cn("feature-shell-eyebrow", className)}
      {...props}
    />
  );
}

function FeatureShellTitle({
  className,
  ...props
}: React.ComponentProps<"h3">) {
  return (
    <h3
      data-slot="feature-shell-title"
      className={cn("feature-shell-title", className)}
      {...props}
    />
  );
}

function FeatureShellDescription({
  className,
  ...props
}: React.ComponentProps<"p">) {
  return (
    <p
      data-slot="feature-shell-description"
      className={cn("feature-shell-description", className)}
      {...props}
    />
  );
}

function FeatureShellMetrics({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="feature-shell-metrics"
      className={cn("feature-shell-metrics", className)}
      {...props}
    />
  );
}

function FeatureShellMetric({
  label,
  value,
  className,
  ...props
}: React.ComponentProps<"div"> & {
  label: string;
  value: React.ReactNode;
}) {
  return (
    <div
      data-slot="feature-shell-metric"
      className={cn("feature-shell-metric", className)}
      {...props}
    >
      <span className="feature-shell-metric-label">{label}</span>
      <span className="feature-shell-metric-value">{value}</span>
    </div>
  );
}

function FeatureShellContent({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="feature-shell-content"
      className={cn("feature-shell-content", className)}
      {...props}
    />
  );
}

function FeatureCard({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="feature-card"
      className={cn("feature-card", className)}
      {...props}
    />
  );
}

function FeatureCardHeader({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="feature-card-header"
      className={cn("feature-card-header", className)}
      {...props}
    />
  );
}

export {
  FeatureShell,
  FeatureShellHeader,
  FeatureShellCopy,
  FeatureShellEyebrow,
  FeatureShellTitle,
  FeatureShellDescription,
  FeatureShellMetrics,
  FeatureShellMetric,
  FeatureShellContent,
  FeatureCard,
  FeatureCardHeader,
};
